module.exports = __webpack_public_path__ + "img/vanguards_2.a0a6692.jpg";